import Menu from 'ui/Menu';

import { useSankeyFormContext } from '../../../contexts/sankeyFormContext';

type Props = {
  field: SankeyFormBooleanField;
  label: string;
  disabled?: boolean;
  disabledTooltip?: string;
};

const MenuCheckbox: React.FC<Props> = ({
  field,
  label,
  disabled,
  disabledTooltip,
}) => {
  const { form } = useSankeyFormContext();
  const isChecked = form.watch(field);

  return (
    <Menu.CheckboxItem
      value={field}
      checked={!!isChecked}
      disabled={disabled}
      title={disabled ? disabledTooltip : undefined}
      onClick={() =>
        !disabled && form.setValue(field, !isChecked, { shouldDirty: true })
      }
      closeOnSelect={false}
    >
      {label}
    </Menu.CheckboxItem>
  );
};

export default MenuCheckbox;
